function getCartCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
}

function handleUnauthorizedAccess(response) {
    // Si c'est un objet, on le convertit en string pour la vérification
    const text = typeof response === 'object' ? JSON.stringify(response) : response;
    
    if (text.includes('Unauthorized access')) {
        alert('Une erreur technique est survenue. Veuillez réessayer.');
        return true;
    }
    return false;
}

async function addProductToCart(product, quantity) {
    // Vérifier si c'est l'abonnement et s'il est déjà dans le panier
    const subscriptionVariantId = 51264927498504;
    if (product == subscriptionVariantId) {
        const cartData = await fetchCartJS();
        const alreadyInCart = cartData.some(item => item.id == subscriptionVariantId);
        if (alreadyInCart) {
            console.log('L\'abonnement est déjà dans le panier, ajout annulé');
            return true; // Retourner success car le produit est déjà là
        }
    }
    
    // X-FS-No-Track : ajouts techniques (abonnement, ré-ajout après retrait) -> pas d'AddToCart
    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { "Content-Type": "application/json", "X-FS-No-Track": "1" },
        body: JSON.stringify({ 
            id: product, 
            quantity: quantity || 1
        })
    });
    return response;
}

async function clearCart() {
    const clearResponse = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json','X-Requested-With': 'XMLHttpRequest'}
        });
}

function displayMessage(message, containerId) {
    let messageContainer = document.getElementById(containerId);
  
    if (typeof message === "object") {
        messageContainer.textContent = Object.values(message).join("<br>");
    } else {
        messageContainer.textContent = message;
    }
}

async function fetchCartJS(){
    const response = await fetch('/cart.js')
    const data = await response.json();
    return data.items;
}

// IP client via ipify, mise en cache pour la session.
// Ne lève jamais d'erreur : renvoie null si ipify est bloqué (adblock) ou trop lent.
let fsClientIpPromise = null;
async function getCustomerIp(timeoutMs = 4000){
    const cachedIp = getSessionStorage('fs_client_ip');
    if (cachedIp) return cachedIp;

    if (!fsClientIpPromise) {
        fsClientIpPromise = (async () => {
            const controller = new AbortController();
            const timer = setTimeout(() => controller.abort(), timeoutMs);
            try {
                const response = await fetch('https://api.ipify.org?format=json', { signal: controller.signal });
                const data = await response.json();
                if (data && data.ip) {
                    try { setSessionStorage('fs_client_ip', data.ip, 3600); } catch (e) {}
                    return data.ip;
                }
                return null;
            } catch (e) {
                console.warn('[Tracking] IP client indisponible (ipify bloqué ou trop lent), envoi sans IP');
                return null;
            } finally {
                clearTimeout(timer);
            }
        })();
        // En cas d'échec, permettre un nouvel essai au prochain appel
        fsClientIpPromise.then(ip => { if (!ip) fsClientIpPromise = null; });
    }
    return fsClientIpPromise;
}

async function getProductMetaData(productId){
    const response = await fetch(`/cart?view=meta-data.json`);
    const data = await response.json();
    return data;
}

function generateHash(data, secretKey) {
    const hash = CryptoJS.SHA256(data + secretKey);
    return hash.toString(CryptoJS.enc.Hex);
}

function shouldApplyDiscount(cartItems){
    const subscriptionDiscount = getSessionStorage('subscription_discount');
    let hasDiscount = false;
    if(subscriptionDiscount) {
        hasDiscount = subscriptionDiscount === 'true';
    }

    const subscriptionActive = getSessionStorage('subscription_active');
    let hasSubscriptionActive = false;
    if(subscriptionActive) {
        hasSubscriptionActive = subscriptionActive === '1';
    }
    
    let hasSubscriptionInCart = false;
    cartItems.forEach(item => {
        if (item.shopify_variant_id == 51264927498504 || item.is_subscription || item.variant_id == 51264927498504) {
            hasSubscriptionInCart = true;
        }
    });
    
    const shouldApplyDiscount = hasDiscount || hasSubscriptionInCart || hasSubscriptionActive;
    return shouldApplyDiscount;
}

function hideLoading(idButton, idLoader) {
    const button = document.getElementById(idButton)
    const loader = document.getElementById(idLoader)

    if (button && loader) {
        button.disabled = false;
        button.style.opacity = '1';
        loader.style.display = 'none';
    }
}

function showLoading(idButton, idLoader) {
    const button = document.getElementById(idButton)
    const loader = document.getElementById(idLoader)

    if (button && loader) {
        button.disabled = true;
        button.style.opacity = '0.3';
        loader.style.display = 'block';
    }
}

function setSessionStorage(name, value, maxAge) {
    const data = {
      value: value,
      timestamp: Date.now(),
      maxAge: maxAge * 1000 // Convertir en millisecondes
    };
    sessionStorage.setItem(name, JSON.stringify(data));
}

function getSessionStorage(name) {
    try {
      const item = sessionStorage.getItem(name);
      if (!item) return null;
      
      const data = JSON.parse(item);
      const now = Date.now();
      
      // Vérifier si l'élément a expiré
      if (data.maxAge && (now - data.timestamp) > data.maxAge) {
        sessionStorage.removeItem(name);
        return null;
      }
      
      return data.value;
    } catch (e) {
      console.warn('Erreur lors de la lecture du sessionStorage:', e);
      return null;
    }
}

async function getAccountCustomerData(email, orderId){
    try {
        const apiKeyData = generateTemporalApiKey();
        const payload = {
            email: email.trim(),
            orderId: orderId.trim(),
            apiKey: apiKeyData.apiKey,
            footprint: apiKeyData.footprint,
            timestamp: Date.now()
        };

        const apiConfig = getApiConfig();
        const response = await fetch(apiConfig.url_account, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        const text = await response.text();

        if (handleUnauthorizedAccess(text)) {
            window.location.reload();
            return;
        }

        const sessionData = JSON.parse(text);
        
        if (sessionData && !sessionData.error) {
            const dataForSession = {
                data: sessionData,
                email: email,
                orderId: orderId,
                _ts: Date.now()
            };
            setSessionStorage('accountCustomerData', JSON.stringify(dataForSession), 3600);
            return dataForSession;
        }

        return sessionData;
        
    } catch (err) {
        console.error('Erreur getAccountCustomerData:', err);
        return { error: 'Erreur de connexion au serveur' };
    }
}

// ==========================================================================
// Tracking Facebook (Conversions API) + TikTok
// ==========================================================================

function setTrackingCookie(name, value, days) {
    document.cookie = `${name}=${value}; path=/; max-age=${days * 86400}; SameSite=Lax`;
}

// Identifiant navigateur Meta (_fbp), créé s'il n'existe pas
function getFbp() {
    let fbp = getCartCookie('_fbp');
    if (!fbp) {
        fbp = `fb.1.${Date.now()}.${Math.floor(Math.random() * 1e10)}`;
        setTrackingCookie('_fbp', fbp, 90);
    }
    return fbp;
}

// Identifiant de clic Meta (_fbc), construit à partir du fbclid de l'URL de la pub
function getFbc() {
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    let fbc = getCartCookie('_fbc');
    if (fbclid && (!fbc || !fbc.endsWith('.' + fbclid))) {
        fbc = `fb.1.${Date.now()}.${fbclid}`;
        setTrackingCookie('_fbc', fbc, 90);
    }
    return fbc || null;
}

function generateEventId(prefix) {
    return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

function getActiveCurrency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
}

// Pixels TikTok utilisables : le proxy exige un token hexadécimal de 40 caractères
function getValidTikTokPixels() {
    if (!Array.isArray(window.tiktokPixelConfigs)) return [];
    return window.tiktokPixelConfigs.filter(({ pixelId, accessToken, pixelName }) => {
        const valid = !!pixelId && /^[a-f0-9]{40}$/.test(accessToken || '');
        if (!valid && !window.__fsTikTokWarned) {
            window.__fsTikTokWarned = true;
            console.warn(`[Tracking] TikTok désactivé pour "${pixelName || pixelId}" : accessToken manquant ou invalide`);
        }
        return valid;
    });
}

async function sendFacebookEvent(eventName, customData, options = {}) {
    if (!Array.isArray(window.pixelConfigs) || window.pixelConfigs.length === 0) {
        console.warn("pixelConfigs non défini ou vide");
        return;
    }

    const clientIP = await getCustomerIp(1500);

    const userData = {
        client_user_agent: navigator.userAgent,
        fbp: getFbp(),
        ...(options.userData || {})
    };
    const fbc = getFbc();
    if (fbc) userData.fbc = fbc;
    if (clientIP) userData.client_ip_address = clientIP;

    const event = {
        event_name: eventName,
        event_time: Math.floor(Date.now() / 1000),
        event_id: options.eventId || generateEventId(eventName),
        event_source_url: window.location.origin + window.location.pathname,
        action_source: "website",
        user_data: userData,
        custom_data: customData
    };

    window.pixelConfigs.forEach(({ pixelId, accessToken }) => {
        fetch(`https://graph.facebook.com/v18.0/${pixelId}/events?access_token=${accessToken}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ data: [event] })
        })
        .then(response => response.json())
        .then(data => console.log(`Facebook ${eventName} Response:`, data))
        .catch(error => console.error(`Facebook ${eventName} Error:`, error));
    });
}

async function sendTikTokEvent(eventName, eventData, options = {}) {
    const tiktokPixels = getValidTikTokPixels();
    if (tiktokPixels.length === 0) return;

    const clientIP = await getCustomerIp(1500);

    tiktokPixels.forEach(({ pixelId, accessToken }) => {
        fetch('https://developer.gemmose.com/tiktok_event.php', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                pixelId: pixelId,
                accessToken: accessToken,
                eventName: eventName,
                eventData: eventData,
                context: {
                    user_agent: navigator.userAgent,
                    ip: clientIP || undefined,
                    page: {
                        url: window.location.href,
                        referrer: document.referrer
                    },
                    user: options.user
                }
            })
        })
        .then(response => response.json())
        .then(data => console.log(`TikTok ${eventName} Response:`, data))
        .catch(error => console.error(`TikTok ${eventName} Error:`, error));
    });
}

// Paramètres de tracking transmis au checkout externe (via la gateway de load balancing)
function getCheckoutTrackingParams() {
    let params = '';
    try {
        params += '&fbp=' + encodeURIComponent(getFbp());
        const fbc = getFbc();
        if (fbc) params += '&fbc=' + encodeURIComponent(fbc);
        const tiktokPixels = getValidTikTokPixels().map(({ pixelId, accessToken }) => pixelId + ':' + accessToken);
        if (tiktokPixels.length > 0) params += '&pixel_tk=' + encodeURIComponent(tiktokPixels.join(';'));
    } catch (e) {
        console.warn('[Tracking] Paramètres de tracking checkout indisponibles', e);
    }
    return params;
}

// Quantités demandées par variante dans la requête /cart/add
// (la réponse Shopify renvoie la quantité totale de la ligne, pas la quantité ajoutée)
function getRequestedQuantities(body) {
    const quantities = {};
    try {
        let entries = [];
        if (body instanceof FormData || body instanceof URLSearchParams) {
            entries = Array.from(body.entries());
        } else if (typeof body === 'string') {
            const json = JSON.parse(body);
            const items = Array.isArray(json.items) ? json.items : [json];
            items.forEach(item => {
                if (item && item.id) quantities[item.id] = parseInt(item.quantity, 10) || 1;
            });
            return quantities;
        }

        const singleId = entries.find(([key]) => key === 'id');
        if (singleId) {
            const quantity = entries.find(([key]) => key === 'quantity');
            quantities[singleId[1]] = parseInt(quantity && quantity[1], 10) || 1;
        }
        // Format items[0][id] / items[0][quantity]
        const itemIds = {};
        const itemQuantities = {};
        entries.forEach(([key, value]) => {
            const match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
            if (match) (match[2] === 'id' ? itemIds : itemQuantities)[match[1]] = value;
        });
        Object.keys(itemIds).forEach(index => {
            quantities[itemIds[index]] = parseInt(itemQuantities[index], 10) || 1;
        });
    } catch (e) {}
    return quantities;
}

// AddToCart : envoyé une fois l'ajout confirmé par Shopify, avec les produits réellement ajoutés
async function trackAddToCart(addedItems, requestedQuantities = {}) {
    const subscriptionVariantId = 51264927498504;
    const items = addedItems.filter(item => item && item.variant_id && item.variant_id != subscriptionVariantId);
    if (items.length === 0) return;

    // Identifiants produits (metafield productId) utilisés pour Meta
    const metaByVariant = {};
    try {
        const productMetaData = await getProductMetaData();
        (productMetaData.meta_product_id_array || []).forEach(meta => {
            metaByVariant[meta.variant_id] = meta;
        });
    } catch (e) {
        console.warn('[Tracking] meta-data du panier indisponible', e);
    }

    const productIDs = [];
    const contentNames = [];
    const contentCategories = [];
    let totalPrice = 0;
    let numItems = 0;

    items.forEach(item => {
        const meta = metaByVariant[item.variant_id];
        if (meta && meta.id) {
            productIDs.push(String(meta.id).split('.')[0]);
        }
        const quantity = requestedQuantities[item.variant_id] || requestedQuantities[item.id] || item.quantity || 1;
        const unitPrice = (item.final_price != null ? item.final_price : item.price) || 0;
        contentNames.push(item.product_title || '');
        if (item.product_type) contentCategories.push(item.product_type);
        totalPrice += (unitPrice * quantity) / 100;
        numItems += quantity;
    });

    const value = parseFloat(totalPrice.toFixed(2));
    const currency = getActiveCurrency();

    const customData = {
        currency: currency,
        value: value,
        content_ids: productIDs,
        content_type: "product",
        content_name: contentNames.join(', '),
        num_items: numItems
    };
    if (contentCategories.length > 0) customData.content_category = contentCategories.join(', ');

    sendFacebookEvent("AddToCart", customData);

    sendTikTokEvent("AddToCart", {
        currency: currency,
        value: value,
        content_type: "product"
    });
}

// Intercepte tous les ajouts au panier (bouton principal, sticky bar, quick-add, bundles…)
(function installAddToCartTracking() {
    if (window.__fsAddToCartTrackingInstalled) return;
    window.__fsAddToCartTrackingInstalled = true;

    const originalFetch = window.fetch;
    window.fetch = function (input, init) {
        const request = originalFetch.apply(this, arguments);
        try {
            const url = typeof input === 'string' ? input : (input && input.url) || String(input);
            const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
            const headers = (init && init.headers) || {};
            const noTrack = headers instanceof Headers ? headers.has('X-FS-No-Track') : !!headers['X-FS-No-Track'];

            if (method === 'POST' && !noTrack && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
                const requestedQuantities = getRequestedQuantities(init && init.body);
                request.then(response => {
                    if (!response.ok) return;
                    response.clone().json()
                        .then(data => trackAddToCart(Array.isArray(data.items) ? data.items : [data], requestedQuantities))
                        .catch(error => console.warn('[Tracking] AddToCart non envoyé', error));
                }).catch(() => {});
            }
        } catch (e) {
            console.warn('[Tracking] Erreur interception ajout panier', e);
        }
        return request;
    };
})();

// Pré-chargement : capture du fbclid dès l'arrivée et IP mise en cache pour les événements suivants
try { getFbp(); getFbc(); } catch (e) {}
getCustomerIp(1500);
